export default "__VITE_ASSET__CxqMUn30__ 100w";